import { useNavigate } from "react-router-dom";
import Button from 'devextreme-react/button';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import { useMemo } from "react";
import { useGetCompany } from "../../../../api/company";
import { useAuth } from "../../../../contexts/auth";

export default function CreateEstimateButton() {

	const navigate = useNavigate();

	const { user } = useAuth();
	const company = useGetCompany(user?.companyId);
	const eeRetailers = company.data?.assignedRetailers.filter(x => x.eeShowInPortal && !!x.easyEstimatorUrl);
	const ee3Retailers = company.data?.assignedRetailers.filter(x => !!x.easyEstimatorV3Url);

	const menuItems = useMemo(() => {

		const result = [];

		if (eeRetailers && eeRetailers.length === 1) {
			result.push({ text: 'Easy Estimator 2.0', icon: 'Inscyth-Easy-Estimator', estimatorUrl: eeRetailers[0].easyEstimatorUrl, openInNewWindow: true });
		} else if (eeRetailers && eeRetailers.length > 1) {
			result.push({
				text: 'Easy Estimator 2.0',
				icon: 'Inscyth-Easy-Estimator',
				items: eeRetailers.map(x => ({ text: x.companyName, estimatorUrl: x.easyEstimatorUrl, openInNewWindow: true }))
			});
		}

		if (ee3Retailers && ee3Retailers.length === 1) {
			result.push({ text: 'Easy Estimator 3.0', icon: 'Inscyth-Easy-Estimator', estimatorUrl: ee3Retailers[0].easyEstimatorV3Url, openInNewWindow: true });
		} else if (ee3Retailers && ee3Retailers.length > 1) {
			result.push({
				text: 'Easy Estimator 3.0',
				icon: 'Inscyth-Easy-Estimator',
				items: ee3Retailers.map(x => ({ text: x.companyName, estimatorUrl: x.easyEstimatorV3Url, openInNewWindow: true }))
			});
		}

		result.push({ text: 'EE Pro Tool', icon: 'Inscyth-EEPro', estimatorUrl: '/cfi/easy-estimator/new', openInNewWindow: false });

		return result;
	}, [eeRetailers, ee3Retailers]);

	return (
		<>
			<Button id="create-estimate-button">
				<i className="dx-icon dx-icon-Inscyth-Easy-Estimator"></i>
				Create Estimate
				<i className={'dx-icon dx-icon-chevrondown'}></i>
			</Button>
			<ContextMenu
				width={165}
				items={menuItems}
				target="#create-estimate-button"
				showEvent="click"
				onItemClick={(e) => {
					const data = e.itemData as any;

					if (!!data.estimatorUrl) {
						if (data.openInNewWindow) {
							window.open(data.estimatorUrl);
						}
						else {
							navigate(data.estimatorUrl);
						}
					}
				}}
			>
				<Position my='left top' at='left bottom'>
				</Position>
			</ContextMenu>
		</>
	);
}